// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__bEAae","notes":"Notes_notes__39NJh"};